export const productsResponse = {
  recommendationItems: [
    {
      itemId: "100398189",
      relevance: 0.8422315716743469,
    },
    {
      itemId: "100395386",
      relevance: 0.6686013340950012,
    },
    {
      itemId: "100396589",
      relevance: 0.6386460661888123,
    },
    {
      itemId: "100396628",
      relevance: 0.5956485867500305,
    },
    {
      itemId: "100391931",
      relevance: 0.588682234287262,
    },
    {
      itemId: "100397995",
      relevance: 0.5774341821670532,
    },
    {
      itemId: "100395235",
      relevance: 0.5731022357940674,
    },
    {
      itemId: "100396674",
      relevance: 0.5293093919754028,
    },
    {
      itemId: "100388571",
      relevance: 0.5291138291358948,
    },
    {
      itemId: "100364938",
      relevance: 0.5088031888008118,
    },
    {
      itemId: "100398333",
      relevance: 0.49765661358833313,
    },
    {
      itemId: "100399718",
      relevance: 0.49012240767478943,
    },
    {
      itemId: "100398778",
      relevance: 0.48909181356430054,
    },
    {
      itemId: "100393724",
      relevance: 0.4744482934474945,
    },
    {
      itemId: "100399000",
      relevance: 0.46675905585289,
    },
    {
      itemId: "100397988",
      relevance: 0.46630924940109253,
    },
    {
      itemId: "100391629",
      relevance: 0.465766042470932,
    },
  ],
  categoryPath: "10067761/10067531",
  categoryPathName: "Baumarkt & Garten/Akkuwerkzeuge",
  brand: "parkside",
  brandName: "PARKSIDE®",
  categoryName: null,
  abTest: null,
  createdAt: "2026-02-02T01:47:36.000+00:00",
};

export const crossResponse = {
  recommendationItems: [
    {
      itemId: "100395235",
      relevance: 0.13075129687786102,
    },
    {
      itemId: "100393724",
      relevance: 0.1128409132361412,
    },
    {
      itemId: "100388571",
      relevance: 0.1009506806731224,
    },
    {
      itemId: "100396589",
      relevance: 0.09662514179944992,
    },
    {
      itemId: "100391182",
      relevance: 0.0652705654501915,
    },
    {
      itemId: "100396622",
      relevance: 0.06430317461490631,
    },
    {
      itemId: "100398022",
      relevance: 0.05948381870985031,
    },
    {
      itemId: "100395251",
      relevance: 0.055413469672203064,
    },
    {
      itemId: "100396382",
      relevance: 0.053634148091077805,
    },
    {
      itemId: "100391222",
      relevance: 0.0514705553650856,
    },
    {
      itemId: "100396315",
      relevance: 0.0390901193022728,
    },
    {
      itemId: "100396290",
      relevance: 0.03683214634656906,
    },
    {
      itemId: "100394777",
      relevance: 0.036820147186517715,
    },
    {
      itemId: "100387450",
      relevance: 0.023632939904928207,
    },
    {
      itemId: "100388469",
      relevance: 0.0366474986076355,
    },
    {
      itemId: "100395204",
      relevance: 0.03584953770041466,
    },
    {
      itemId: "100396678",
      relevance: 0.0342358723282814,
    },
    {
      itemId: "100399000",
      relevance: 0.03206915408372879,
    },
    {
      itemId: "100345897",
      relevance: 1,
    },
  ],
  categoryPath: "-",
  categoryPathName: "-",
  brand: "-",
  brandName: "-",
  categoryName: null,
  abTest: null,
  createdAt: "2026-02-02T04:35:09.000+00:00",
};

export const categoryViewedProductsResponse = {
  recommendationItems: [
    {
      itemId: "100366673",
      relevance: null,
    },
    {
      itemId: "100398189",
      relevance: null,
    },
    {
      itemId: "100392941",
      relevance: null,
    },
    {
      itemId: "100359881",
      relevance: null,
    },
    {
      itemId: "100397995",
      relevance: null,
    },
    {
      itemId: "100395386",
      relevance: null,
    },
    {
      itemId: "100398430",
      relevance: null,
    },
    {
      itemId: "100398778",
      relevance: null,
    },
    {
      itemId: "100396589",
      relevance: null,
    },
    {
      itemId: "100398278",
      relevance: null,
    },
    {
      itemId: "100382242",
      relevance: null,
    },
    {
      itemId: "100381667",
      relevance: null,
    },
    {
      itemId: "100388457",
      relevance: null,
    },
    {
      itemId: "100399718",
      relevance: null,
    },
    {
      itemId: "100391528",
      relevance: null,
    },
    {
      itemId: "100379105",
      relevance: null,
    },
    {
      itemId: "100385314",
      relevance: null,
    },
    {
      itemId: "100396674",
      relevance: null,
    },
    {
      itemId: "100396678",
      relevance: null,
    },
    {
      itemId: "100393608",
      relevance: null,
    },
  ],
  categoryPath: null,
  categoryPathName: null,
  brand: null,
  brandName: null,
  categoryName: "Akkuwerkzeuge",
  abTest: null,
  createdAt: "+58059-11-07T05:32:52.000+00:00",
};

export const brandViewedProductsResponse = {
  recommendationItems: [
    {
      itemId: "100366673",
      relevance: null,
    },
    {
      itemId: "100392312",
      relevance: null,
    },
    {
      itemId: "100359881",
      relevance: null,
    },
    {
      itemId: "100397995",
      relevance: null,
    },
    {
      itemId: "100395386",
      relevance: null,
    },
    {
      itemId: "100398430",
      relevance: null,
    },
    {
      itemId: "100398778",
      relevance: null,
    },
    {
      itemId: "100396589",
      relevance: null,
    },
    {
      itemId: "100398278",
      relevance: null,
    },
    {
      itemId: "100398629",
      relevance: null,
    },
    {
      itemId: "100387821",
      relevance: null,
    },
    {
      itemId: "100324645",
      relevance: null,
    },
    {
      itemId: "100382242",
      relevance: null,
    },
    {
      itemId: "100381667",
      relevance: null,
    },
    {
      itemId: "100388457",
      relevance: null,
    },
    {
      itemId: "100388342",
      relevance: null,
    },
    {
      itemId: "100373545",
      relevance: null,
    },
    {
      itemId: "100391528",
      relevance: null,
    },
    {
      itemId: "100385250",
      relevance: null,
    },
  ],
  categoryPath: null,
  categoryPathName: null,
  brand: null,
  brandName: "PARKSIDE®",
  categoryName: null,
  abTest: null,
  createdAt: "+58059-11-07T05:32:52.000+00:00",
};
